import axios from 'axios'
import { getToken } from './token'
import router from '../router'
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// axios.defaults.headers['Content-Type'] = 'multipart/form-data'

const baseurl = 'https://yunthee.com/website/'

// 创建axios实例
const service = axios.create({
	baseURL: baseurl,
	// 超时
	timeout: 15000
})
// request拦截器
service.interceptors.request.use(
	config => {
		config.headers['Authorization'] = 'Bearer ' + getToken()
		return config
	},
	error => {
		console.log(error)
	}
)
// 响应拦截器
service.interceptors.response.use(res => {
	// 未设置状态码则默认成功状态
	if (res.data.code === 401) {
		// eslint-disable-next-line no-irregular-whitespace
		router.push('/')
	}
	return res.data
})

export default service
